/**
 * Toolbar component - handles responsive layout of action buttons
 */

import { ReactNode } from 'react';
import './Toolbar.css';

interface ToolbarProps {
  children: ReactNode;
}

export function Toolbar({ children }: ToolbarProps) {
  return (
    <div className="toolbar">
      {children}
    </div>
  );
}
